import mockResidentsInfo from '@/assets/json/mock-residents-info.json';

export interface MockResidentData {
  name: string;
  description: string;
  image: string;
  url?: string | null;
}

type MockResidentsMap = Record<string, MockResidentData>;

const records = mockResidentsInfo as MockResidentsMap;

export function getMockResident(residentId: string): MockResidentData | null {
  if (records[residentId]) {
    return records[residentId];
  }

  const id = Number(residentId);
  if (Number.isFinite(id) && id > 0) {
    const key = id % 2 === 0 ? '2' : '1';
    if (records[key]) return records[key];
  }

  return records.default ?? null;
}
